// state <- 値の格納のみ
export const state = {
	isLogin: false,
	isController: false,
	accessToken: '',
	userName: '',
	
	// ランステ月額状況
	statusMonthly: {},
	// ランステチケット状況
	statusTicket: {},
	// ランステ予約状況
	statusReservation: {},
	
	// チケット種類
	listTicket: [],
	// 月額種類
	listMonthly: [],
	// 半年種類
	listHalfAnnual: [],
	// 年間種類
	listAnnual: [],

	// QRチェックインコード
	codeQrCheckin: '',
	
	loginError: '',
	apiError: '',	// APIがstatus=errorの際に戻してきたメッセージ
	
	// ランステ受付(月額/チケット)のレスポンス
	responseRunstReception: null,
	
	// ローディング中フラグ
	flagLoading: false,
	
	// ランステ利用状況取得中
	runningRunstLog: false,
	// ランステ利用状況
	listRunstLog: [],

	// ランステチケット利用状況取得中
	runningTicketLog: false,
	// ランステチケット利用状況
	listTicketLog: [],

	// ランステ月額会員利用状況取得中
	runningMonthlyLog: false,
	// ランステ月額会員利用状況
	listMonthlyLog: [],
	// ランステ月額自動継続フラグ
	autoMonthlyFlag: true,

	// 予約状況取得中
	runningReservation: false,
	// 予約状況
	listReservation: [],

	// プロフィール情報
	dataUser: {},
	
	// 保有ポイント
	ufPoint: '',
	// ポイントログ
	logPoint: [],
}

export const mutations = {
	logout(state) {
		state.isLogin = false;
		state.isController = false;
		state.accessToken = '';
		state.userName = '';
		
		// ランステ月額状況
		state.statusMonthly = {};
		// ランステチケット状況
		state.statusTicket = {};
		// ランステ予約状況
		state.statusReservation = {};
	},
	setLogin(state, param) {
		state.isLogin = param;
	},
	setLoginError(state, param) {
		state.loginError = param;
	},
	setController(state, param) {
		state.isController = param;
	},
	setAccessToken(state, param) {
		state.accessToken = param;
	},
	setUserName(state, param) {
		state.userName = param;
	},

	setApiError(state, param) {
		state.apiError = param;
	},
	setCodeQqCheckin(state, param) {
		state.codeQrCheckin = param;
	},
	setRunstReception(state, param) {
		state.responseRunstReception = param;
	},

	// ランステ月額状況
	setMonthlyStatus(state, param) {
		state.statusMonthly = param ? param : {};
	},
	// ランステチケット状況
	setTicketStatus(state, param) {
		state.statusTicket = param ? param : {};
	},
	// ランステ予約状況
	setReservationStatus(state, param) {
		state.statusReservation = param ? param : {};
	},

	// ローディング中フラグ
	setLoading(state, param) {
		state.flagLoading = param ? true : false;
	},

	// ランステ利用状況取得中
	setRunningRunstLog(state, param) {
		state.runningRunstLog = param ? true : false;
	},

	// ランステ利用状況
	setListRunstLog(state, param) {
		state.listRunstLog = param;
	},

	// ランステチケット利用状況取得中
	setRunningTicketLog(state, param) {
		state.runningTicketLog = param ? true : false;
	},

	// ランステチケット利用状況
	setListTicketLog(state, param) {
		state.listTicketLog = param;
	},

	// ランステ月額会員利用状況取得中
	setRunningMonthlyLog(state, param) {
		state.runningMonthlyLog = param ? true : false;
	},

	// ランステ月額会員利用状況
	setListMonthlyLog(state, param) {
		state.listMonthlyLog = param;
	},

	// ランステ月額自動継続フラグ
	setAutoMonthlyFlag(state, param) {
		state.autoMonthlyFlag = param ? true : false;
	},

	// 予約状況取得中
	setRunningReservation(state, param) {
		state.runningReservation = param;
	},

	// 予約状況
	setListReservation(state, param) {
		state.listReservation = param;
	},
	
	// チケット種類
	setListTicket(state, param) {
		state.listTicket = param;
	},
	// 月額種類
	setListMonthly(state, param) {
		state.listMonthly = param;
	},
	// 半年間種類
	setListHalfAnnual(state, param) {
		state.listHalfAnnual = param;
	},
	// 年間種類
	setListAnnual(state, param) {
		state.listAnnual = param;
	},

	setProfile(state, param) {
		state.dataUser = param;
	},
	setProfileProvice(state, param) {
		state.dataUser.province = param;
	},
	setProfileCity(state, param) {
		state.dataUser.city = param;
	},

	// 保有ポイント
	setUfPoint(state, param) {
		state.ufPoint = param;
	},
	// ポイントログ
	setPointLog(state, param) {
		state.logPoint = param;
	}

};

export const getters = {
	isLogin: (state) => { return state.isLogin; },
	getLoginError: (state) => {
		return state.loginError;
	},
	isController: (state) => { return state.isController; },
	getAccessToken: (state) => { return state.accessToken; },
	getUserName: (state) => { return state.userName; },
	getApiError: (state) => { return state.apiError; },
	getCodeQqCheckin: (state) => { return state.codeQrCheckin; },
	
	getResponseRunstReception: (state) => { return state.responseRunstReception; },

	// ランステ月額状況
	getMonthlyStatus: (state) => { return state.statusMonthly },
	// サブスクは月額会員か
	isSubscMonthly: (state) => {
		return state.statusMonthly && state.statusMonthly.kind_info && state.statusMonthly.kind_info.type == 'monthly';
	},
	// サブスクは半年会員か
	isSubscHalfAnnual: (state) => {
		return state.statusMonthly && state.statusMonthly.kind_info && state.statusMonthly.kind_info.type == 'halfannual';
	},
	// サブスクは年会員か
	isSubscAnnual: (state) => {
		return state.statusMonthly && state.statusMonthly.kind_info && state.statusMonthly.kind_info.type == 'annual';
	},
	// ランステチケット状況
	getTicketStatus: (state) => { return state.statusTicket },
	// ランステ予約状況
	getReservationStatus: (state) => { return state.statusReservation },

	// ランステ利用可能か
	isUseableRunst: (state) => {
		const dt = new Date();
		const ymd = ('0000'+dt.getFullYear()).slice(-4)+'-'+('00'+(dt.getMonth()+1)).slice(-2)+'-'+('00'+dt.getDate()).slice(-2);
		if(state.listReservation) {
			for(let i in state.listReservation) {
				if(state.listReservation[i].open_date == ymd) return true;
			}
		}

		if(state.statusMonthly.status == 1) return true;
		if(state.statusTicket.status == 1) return true;
		if(state.statusReservation.status == 1) return true;
		return false;
	},

	// ローディング中フラグ
	isLoading: (state) => { return state.flagLoading; },
	
	// ランステ利用状況取得中
	getRunningRunstLog: (state) => { return state.runningRunstLog; },

	// ランステ利用状況
	getListRunstLog: (state) => { return state.listRunstLog; },

	// ランステチケット利用状況取得中
	getRunningTicketLog: (state) => { return state.runningTicketLog; },
	// ランステチケット利用状況
	getListTicketLog: (state) => { return state.listTicketLog; },

	// ランステ月額会員利用状況取得中
	getRunningMonthlyLog: (state) => { return state.runningMonthlyLog; },
	// ランステ月額会員利用状況
	getListMonthlyLog: (state) => { return state.listMonthlyLog; },
	// ランステ月額自動継続フラグ
	getAutoMonthlyFlag: (state) => { return state.autoMonthlyFlag; },

	// 予約状況取得中
	getRunningReservation: (state) => { return state.runningReservation; },

	// 予約状況
	getListReservation: (state) => { return state.listReservation; },

	// チケット種類
	getListTicket: (state) => { return state.listTicket; },
	// 月額種類
	getListMonthly: (state) => { return state.listMonthly; },
	// 半年額種類
	getListHalfAnnual: (state) => { return state.listHalfAnnual; },
	// 年額種類
	getListAnnual: (state) => { return state.listAnnual; },

	// ユーザー情報
	getDataUser: (state) => { return state.dataUser; },

	// 保有ポイント
	getUfPoint: (state) => { return state.ufPoint; },
	// ポイントログ
	getPointLog: (state) => { return state.logPoint; },

};

export default {
	namespaced: true,
	state,
	getters,
	mutations
}
